import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetMuscoGauge() {

  return (

      <GaugeWithNeedle realAge={66} chronologicalAge={62} />
    
  );
};




